import React, { ReactNode } from 'react';
import SharedSelection from './SharedSelection';
import { useFieldKeyPath } from 'app/models/entityStateSync/keypath';
import { EntityFields, EntityStringId, IEntityType, ExtractIEntity } from 'app/types/entity';
import { ExtractProps } from 'app/utils/types';

interface IProps<T extends IEntityType<any>>
extends Omit<ExtractProps<typeof SharedSelection>, 'path'> {
  readonly id: EntityStringId;
  readonly field: keyof EntityFields<ExtractIEntity<T>>;
  readonly type: T;
  readonly children: ReactNode;
}

export default function EntityFieldSharedSelection<T extends IEntityType<any>>(
  { type, id, field, ...props }: IProps<T>,
) {
  const keyPath = useFieldKeyPath({ id, type, field });
  return (
    <SharedSelection {...props} path={keyPath} />
  );
}
